module.exports = __webpack_public_path__ + "img/photo_2019-11-22_03-13-49.ee15f0bd.jpg";